import { addReducer } from '../Store';
import { Chat } from './reducers';

function addReducers() {
  addReducer('Chat', Chat);
}

addReducers();

if (module.hot) {
  module.hot.accept('./reducers', addReducers);
}
